<template>
  <v-menu
    v-model="isOpen"
    offset-y
    :close-on-content-click="true"
    min-width="100%"
    max-width="100%"
    content-class="info-mobile-menu__content"
    transition="slide-y-transition"
  >
    <template #activator="{ on, attrs }">
      <div
        class="info-mobile-menu__activator d-flex align-center justify-center w-100 pa-4 position-relative cursor-pointer"
        v-bind="attrs"
        v-on="on"
      >
        <v-icon
          v-if="isOpen"
          class="info-mobile-menu__icon info-mobile-menu__icon_left primary--text"
          size="20"
        >
          ui-icon-check
        </v-icon>
        <h1
          class="text-body-1 ma-0"
          :class="isOpen ? 'primary--text' : 'text--text'"
        >
          {{ t(title, options) }}
        </h1>
        <v-icon
          v-if="!isOpen"
          class="info-mobile-menu__icon info-mobile-menu__icon_right text-secondary--text"
          size="20"
        >
          ui-icon-arrow-down
        </v-icon>
      </div>
    </template>

    <v-list class="py-0">
      <v-list-item
        v-for="route in visibleRoutes"
        :key="route.path"
        :href="route.path"
        class="justify-center"
      >
        <v-list-item-title class="text-body-1 text--text text-center">
          {{ t(route.label, options) }}
        </v-list-item-title>
      </v-list-item>
      <v-list-item
        class="justify-center"
        @click="isOpen = false"
      >
        <v-list-item-title class="text-body-1 text-secondary--text text-center">
          {{ t('Свернуть', options) }}
        </v-list-item-title>
        <v-icon
          class="text-secondary--text ml-2"
          size="20"
        >
          ui-icon-arrow-up
        </v-icon>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue'
import I18NextVue from 'i18next'

type MenuRoute = {
  path?: string
  label: string
}

const props = defineProps<{
  title: string
  currentPath: string
  routes: MenuRoute[]
}>()

const { t, language } = I18NextVue
const options = { ns: language }
const isOpen = ref(false)

const visibleRoutes = computed(() => (
  props.routes.filter(route => route.path && route.path !== props.currentPath)
))
</script>

<style scoped lang="scss">
@import 'src/styles/variables';

.info-mobile-menu {
  &__activator {
    min-height: 48px;
    border-bottom: 1px solid $ui-kit-bg-gray-60;
  }

  &__icon {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);

    &_left {
      left: 0;
      padding: 12px;
    }

    &_right {
      right: 16px;
    }
  }
}
</style>

<style lang="scss">
.info-mobile-menu__content {
  left: 0 !important;
  right: 0 !important;
  max-width: none !important;
  width: 100%;
}
</style>
